import template from './otherAdviser.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    otherAdviser: '<',
    contacts: '<',
    workflow: '<',
    assets: '<',
    homeLoanSecurities: '<',
    insurances: '<',
    countries: '<',
    isDealOwnerBroker: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor(
      $rootScope,
      helperService,
      otherAdvisersService,
      assetsService,
      liabilitiesService,
      OtherAdviser,
      PersonalTitle,
      CONTACT,
      GOOGLEMAPS
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
      ctrl.availableStates = [];
      ctrl.availableTitles = [];
      ctrl.availableLiabilityTypes = [];
      ctrl.organizationCountry = '';

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.availableLiabilityTypes = liabilitiesService.getAvailableLiabilityTypes();
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.insurances = ctrl.insurances || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
      };

      ctrl.getContactEmployers = () => {
        if (ctrl.contacts.length) {
          const contact = ctrl.contacts.find(
            (c) => ctrl.otherAdviser.idContacts.indexOf(c.id) > -1 && !c.isCompany
          );
          if (contact) {
            const employments = contact.person.employments.filter((e) => e.isCurrent);
            return employments.length !== undefined ? employments : [];
          }
        }
        return [];
      };

      ctrl.getLinkedHomeLoanSecurities = () => {
        let securities = [];
        if (ctrl.homeLoanSecurities.length) {
          securities = ctrl.homeLoanSecurities.filter(
            (s) => s.getName() !== '' && s.value !== null && s.value !== 0
          );
        }
        return securities;
      };

      ctrl.getLinkedAssets = (liabilityType) => {
        assetsService.getLinkedAssets(liabilityType, ctrl.assets);
      };

      /*
       * Save other adviser
       * --------------------------------------------------------------------------------
       */
      ctrl.saveOtherAdviser = () => ctrl.onFinished({ otherAdviser: ctrl.otherAdviser });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
